export default __webpack_public_path__ + "3ff16b50e5c2f4c5f6ac43e3f2a70283.png";